/**
 * InboxProgress (PHASE1 §7.2). A slim header strip showing how many bookings
 * still await categorization. Reflects the optimistic `remaining` count from
 * the controller, so it ticks down instantly as the user works the queue.
 */
import { CheckCircle2, Inbox } from 'lucide-react';

export interface InboxProgressProps {
  remaining: number;
}

export function InboxProgress({ remaining }: InboxProgressProps) {
  const done = remaining === 0;
  const noun = remaining === 1 ? 'Buchung' : 'Buchungen';

  return (
    <div className="flex items-center gap-2 border-b border-slate-100 pb-3 text-sm dark:border-slate-800/70">
      {done ? (
        <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-400" aria-hidden />
      ) : (
        <Inbox className="h-4 w-4 text-sky-600 dark:text-sky-400" aria-hidden />
      )}
      <span className="text-slate-600 dark:text-slate-400">
        {done ? (
          'Eingang leer'
        ) : (
          <>
            Noch{' '}
            <span className="font-semibold tabular-nums text-slate-900 dark:text-slate-100">
              {remaining}
            </span>{' '}
            {noun} zu
            kategorisieren
          </>
        )}
      </span>
    </div>
  );
}
